export default "__VITE_ASSET__BhIh2JKC__"